var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.178,34.62H39.822C17.864,34.62,0,52.484,0,74.442c0,17.955,0,345.234,0,363.116 c0,21.958,17.864,39.822,39.822,39.822h432.356c21.958,0,39.822-17.864,39.822-39.822c0-17.89,0-345.167,0-363.116 C512,52.484,494.136,34.62,472.178,34.62z M477.867,437.557c0,3.137-2.552,5.689-5.689,5.689H39.822 c-3.137,0-5.689-2.552-5.689-5.689V153.838h443.733V437.557z M477.867,119.705H34.133V74.442c0-3.137,2.552-5.689,5.689-5.689 h432.356c3.137,0,5.689,2.552,5.689,5.689V119.705z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.805,
    cy: 94.23,
    r: 12.836
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.959,
    cy: 94.23,
    r: 12.836
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.112,
    cy: 94.23,
    r: 12.836
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.581,334.442c4.44,13.701,22.872,16.101,30.636,3.9l10.454-16.432l10.454,16.432 c7.744,12.169,26.195,9.801,30.636-3.9l19.857-61.278c2.906-8.967-2.008-18.591-10.975-21.497 c-8.971-2.906-18.591,2.009-21.497,10.975l-8.681,26.791l-5.393-8.478c-6.695-10.52-22.094-10.538-28.801,0l-5.392,8.478 l-8.681-26.79c-2.906-8.966-12.526-13.882-21.497-10.975c-8.967,2.906-13.88,12.529-10.975,21.496L81.581,334.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.911,334.442c4.446,13.72,22.905,16.052,30.636,3.9L256,321.911l10.454,16.432c7.762,12.2,26.196,9.8,30.636-3.9 l19.855-61.278c2.906-8.967-2.008-18.59-10.975-21.496c-8.974-2.907-18.591,2.008-21.497,10.975l-8.681,26.79l-5.392-8.478 c-6.695-10.52-22.094-10.538-28.801,0l-5.392,8.478l-8.681-26.79c-2.905-8.966-12.527-13.882-21.496-10.975 c-8.967,2.906-13.88,12.529-10.975,21.496L214.911,334.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.241,334.442c4.446,13.72,22.905,16.051,30.636,3.9l10.454-16.432l10.454,16.432c7.762,12.2,26.195,9.8,30.636-3.9 l19.855-61.278c2.906-8.967-2.008-18.59-10.975-21.496c-8.973-2.907-18.591,2.008-21.496,10.975l-8.681,26.79l-5.392-8.478 c-6.695-10.52-22.095-10.538-28.801,0l-5.393,8.478l-8.681-26.791c-2.906-8.966-12.531-13.881-21.497-10.975 c-8.967,2.906-13.88,12.53-10.974,21.497L348.241,334.442z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/Domain.2b2f9fe88e573e34cbd78be2d9f7858f.svg";
export { ForwardRef as ReactComponent };